"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldPasswordQueryRequest = void 0;
var OldPasswordQueryRequest = /** @class */ (function () {
    function OldPasswordQueryRequest() {
    }
    return OldPasswordQueryRequest;
}());
exports.OldPasswordQueryRequest = OldPasswordQueryRequest;
;
//# sourceMappingURL=oldPasswordQuery.request.js.map